import React, { useContext, useState } from 'react';
import {
  TypedUseSelectorHook,
  useSelector as useReduxSelector,
} from 'react-redux';
import { useParams } from 'react-router-dom';

import { faTimes } from '@fortawesome/pro-light-svg-icons/faTimes';

import { RootState } from '../../../../app/rootReducer';
import { IconLink } from '../../../../common/components/IconLink';
import { Resource } from '../../../../common/constants/resource';
import ElementLocators from '../../../../common/ElementLocators';
import { FeatureFlagsContext } from '../../../../common/featureFlagsWrapper';
import { tasksResolved } from '../../../../common/helpers';
import { SnackbarContext } from '../../../layout/SnackbarContext';
import { ITask } from '../../../tasks/interfaces/ITask';
import { getAllTasks } from '../../../tasks/slice/taskListSlice';
import { useDecisionSubmit } from '../../decision/useDecisionSubmit';
import { InvalidDrawer } from '../InvalidDrawer';
import EditReinstatementDecision from './EditReinstatementDecision';
import SummaryReinstatementDecision from './SummaryReinstatementDecision';

export const useSelector: TypedUseSelectorHook<RootState> = useReduxSelector;

export default function WithdrawReinstatement() {
  const { id } = useParams<{ id: string }>();
  const [isOpen, setIsOpen] = useState(false);
  const [description, setDescription] = useState('');
  const [isSummary, showSummary] = useState(false);
  const tasks: ITask[] = useSelector(state => getAllTasks(state.taskList));
  const isValid = tasksResolved(tasks);
  const { submitCreate } = useDecisionSubmit(id || '', 'reinstate_withdraw');

  const { openSnacks, setSnacks } = useContext(SnackbarContext);
  const { flags } = useContext(FeatureFlagsContext);
  const isReinstatementLetterAutomationEnabled = Boolean(
    flags.isReinstatementLetterAutomationEnabled,
  );

  function onConfirmClick() {
    if (id) {
      submitCreate(
        { description },
        null,
        undefined,
        false,
        isReinstatementLetterAutomationEnabled
          ? { enabled: true, openSnacks, updateSnacks: setSnacks }
          : undefined,
      );
    }
    setIsOpen(false);
  }

  function onReviewClick() {
    showSummary(true);
  }

  return (
    <>
      {!isValid && (
        <InvalidDrawer
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          labelCopy={Resource.WITHDRAW_REINSTATEMENT}
        />
      )}
      {isValid &&
        (isSummary ? (
          <SummaryReinstatementDecision
            isOpen={isOpen}
            description={description}
            showSummary={showSummary}
            onConfirmClick={onConfirmClick}
            drawerName={Resource.WITHDRAW_REINSTATEMENT}
          />
        ) : (
          <EditReinstatementDecision
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            description={description}
            setDescription={setDescription}
            showSummary={showSummary}
            onReviewClick={onReviewClick}
            drawerName={Resource.WITHDRAW_REINSTATEMENT}
          />
        ))}
      <IconLink
        onClick={() => setIsOpen(true)}
        icon={faTimes}
        copy={Resource.WITHDRAW_REINSTATEMENT}
        locator={ElementLocators.WITHDRAW_DECISION_LINK}
      />
    </>
  );
}
